function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-14,.cls-15,.cls-18,.cls-2,.cls-6,.cls-8{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-14,.cls-2{stroke:#e5e5e5;}.cls-2{stroke-width:4.36px;}.cls-16,.cls-3{fill:#777;}.cls-4{fill:#383838;}.cls-5{fill:#fffff0;}.cls-6{stroke:#81e6d9;stroke-width:5.14px;}.cls-11,.cls-7{fill:#8ce08c;}.cls-8{stroke:#2f855a;stroke-width:3.65px;}.cls-9{fill:#2f855a;}.cls-10{fill:#c2c2c2;}.cls-11,.cls-16,.cls-17{fill-rule:evenodd;}.cls-12{fill:#ed8936;}.cls-13,.cls-17{fill:#81e6d9;}.cls-14,.cls-15{stroke-width:3.06px;}.cls-15{stroke:#909090;}.cls-18{stroke:#fff;stroke-width:16.23px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "vector"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M626.51,120.45C687.65,175,733.72,251.23,771.05,364.76s65.72,264.18,4.59,363.52S563.85,875.66,452.94,835.7,270.85,668.24,192.25,568.9,27.63,398.38,5.79,305.59c-22-93,20.53-207.63,99.13-262.22S298.14-5.75,393.77,13.68C489.18,32.89,565.38,65.86,626.51,120.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M355.79,194.59,7.91,560.05l607.51,118.4Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "685.98 491.97 714.49 868.8 676.94 876.87 587.74 596.93 685.98 491.97"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M694.68,606.91,686,492l-98.24,105,21.2,66.53C634.43,640.14,665.39,616.77,694.68,606.91Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 133.35,
  y: 45.7,
  width: 573.9,
  height: 360.24
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M133.35,185.74c57.39,0,57.39,102,114.78,102s57.39-102,114.78-102,57.39,102,114.78,102,57.39-102,114.78-102,57.39,102,114.79,102"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M684.25,868.8c-14,0-48.8,1.74-70.69,38.9H714.49V868.8Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 628.22,
  cy: 204.03,
  r: 40.48
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M607.19,192.62c.56-4.14-.56-7.71-2.48-8s-3.94,2.89-4.5,7,.56,7.7,2.48,8S606.64,196.76,607.19,192.62Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 628.22,
  cy: 124.36,
  r: 25.31
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M460.73,757.3c-14,0-48.8,1.74-70.69,38.89H491V757.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M684.28,186.46a30.22,30.22,0,1,1,30.21,30.22A30.22,30.22,0,0,1,684.28,186.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M422.09,414.29a30.21,30.21,0,1,1,30.21,30.22A30.21,30.21,0,0,1,422.09,414.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M624.36,252.69c88.55,0,88.55,195.21,79.86,212.47s-142.56,14.65-152.41,0S538.12,252.7,624.36,252.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M553,482.58c-43.27,2.18-147.39,21.82-145.34,52.88.93,14.1,49.09,225.89,49.09,225.89L491,757.3s8.79-138.7,5.53-157.54c107.72,26,228.07,14.07,188.81-109.92C647.47,497.67,568,494,553,482.58Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "160.22 55.6 145.28 81.48 175.16 81.48 160.22 55.6"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-12",
  cx: 197.94,
  cy: 67.53,
  r: 14.33
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 225.45,
  y: 54.38,
  width: 27.09,
  height: 27.09
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-12",
  x: 327.34,
  y: 796.19,
  width: 214.6,
  height: 111.5
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-14",
  x1: 103.39,
  y1: 92.47,
  x2: 707.87,
  y2: 92.47
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M102.47,826C102,814.05,85.87,764.37,57,713.22"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M107.19,826c0-67.06,50.37-199.31,92.68-227.52"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M78.3,822.53h54.35a16.07,16.07,0,0,1,16.08,16.07v53a16.08,16.08,0,0,1-16.08,16.08H78.3a16.08,16.08,0,0,1-16.07-16.08v-53A16.07,16.07,0,0,1,78.3,822.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M126.07,671.53a30.61,30.61,0,1,1,30.61,30.61A30.61,30.61,0,0,1,126.07,671.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M44.24,610.56a22.53,22.53,0,1,1,22.53,22.53A22.53,22.53,0,0,1,44.24,610.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M101,771.67a40,40,0,1,1,40,40A40,40,0,0,1,101,771.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M184.08,593.84a9.9,9.9,0,1,1,9.89,9.89A9.89,9.89,0,0,1,184.08,593.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M64.3,688.36l-21,28.42L29.21,684.42,15.08,652.06l35.09,4L85.26,660Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M37.29,774.22l-22.21,9.59,2.8-24,2.79-24,19.41,14.44L59.5,764.62Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 651.93,
  cy: 410.65,
  r: 37.02
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M554.55,340.26a37,37,0,1,1-7.76,73.35"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-6",
  cx: 644.59,
  cy: 320.82,
  r: 37.02
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M612.41,254.06a37,37,0,0,1-36.88,33.8c-.89,0-1.76,0-2.63-.09"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M572.41,363c3.47-19.63,8.72-38.85,16.36-55"
})));

var SvgWatermelonPackIllustration07 = function SvgWatermelonPackIllustration07(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 811.26 907.7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelonPackIllustration07, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-07.9a2dfe1e.svg";
export { ForwardRef as ReactComponent };